import * as React from 'react';

import './mentor-card.css';

import { MentorCardProps } from '../../types/pages/Landing';

class MentorCard extends React.Component<MentorCardProps> {
  public constructor(props: MentorCardProps) {
    super(props);
  }

  public render() {
    const { firstName, lastName, company, jobTitle, profilePictureUrl } = this.props.mentor;
    return (
      <div className="mentor-tile">
        <div className="columns is-centered">
          <img className="profile-picture" src={profilePictureUrl} />
        </div>
        <div>
          <p className="name">{firstName} {lastName}</p>
        </div>
        <div>
          <p className="job-title">{jobTitle}</p>
        </div>
        <div>
          <p className="company">{company}</p>
        </div>
      </div>
    )
  }
}

export default MentorCard;



// WEBPACK FOOTER //
// ./src/pages/landing/MentorCard.tsx